export const SUBSCRIPTIONS_PRICES = {
  0: 199,
  1: 445,
  2: 129
};



// WEBPACK FOOTER //
// ./src/modules/examPrepDashboard/constants/subscription.js